<template>
  <div class="talent-pager">
    <yxt-pagination
      :background="background"
      :current-page="currentPage"
      :page-size.sync="pageSize"
      :layout="layout"
      :page-sizes="pageSizes"
      :total="total"
      v-bind="$attrs"
      :show-on-single-page="false"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />
  </div>
</template>

<script>
export default {
  name: 'YxtbizEvalPager',
  props: {
    background: {
      type: Boolean,
      default: false
    },
    total: {
      type: Number,
      default: 0
    },
    page: {
      type: Number,
      default: 0
    },
    limit: {
      type: Number,
      default: 0
    },
    pageSizes: {
      type: Array,
      default: () => [10, 20, 50, 100]
    },
    layout: {
      type: String,
      default: 'total, sizes, prev, pager, next'
    }
  },
  data() {
    return {
      currentPage: 1
    };
  },
  watch: {
    page(val) {
      if (val === 0) this.currentPage = 1;
    }
  },
  computed: {
    pageSize: {
      get() {
        return this.limit;
      },
      set(val) {
        this.$emit('update:limit', val);
      }
    }
  },
  methods: {
    handleSizeChange() {
      this.$emit('pagination');
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.$emit('update:page', (val - 1) * this.pageSize);
      this.$emit('pagination');
    }
  }
};
</script>
<style lang="scss" scoped>
.talent-pager {
  float: right;
  margin-top: 16px;
}
</style>
